const defaultHeaders = () => ({
    'Content-Type': 'application/json; charset=UTF-8',
    'Authorization': sessionStorage.getItem('agronetToken'),
    'Local': localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en'
});

const handleJsonResponse = (res, errorAction, dispatch) => {
    if (res.status === 200) {
        return res.json();
    }

    dispatch(errorAction(`Error: ${res.status} ${res.statusText}`));
    return Promise.reject(res);
};

const handleEmptyResponse = (res, errorAction, dispatch) => {
    if (res.status === 200 || res.status === 204) {
        return true;
    }

    dispatch(errorAction(`Error: ${res.status} ${res.statusText}`));
    return Promise.reject(res);
};

export const getWeatherStationStatusReportsPending = () => ({
    type: 'GET_WEATHER_STATION_STATUS_REPORTS_PENDING'
});

export const getWeatherStationStatusReportsSuccess = reports => ({
    type: 'GET_WEATHER_STATION_STATUS_REPORTS_SUCCESS',
    reports
});

export const getWeatherStationStatusReportsError = error => ({
    type: 'GET_WEATHER_STATION_STATUS_REPORTS_ERROR',
    error
});

export const getWeatherStationStatusReportPending = () => ({
    type: 'GET_WEATHER_STATION_STATUS_REPORT_PENDING'
});

export const getWeatherStationStatusReportSuccess = report => ({
    type: 'GET_WEATHER_STATION_STATUS_REPORT_SUCCESS',
    report
});

export const getWeatherStationStatusReportError = error => ({
    type: 'GET_WEATHER_STATION_STATUS_REPORT_ERROR',
    error
});

export const getStationsForStatusReportPending = () => ({
    type: 'GET_STATIONS_FOR_STATUS_REPORT_PENDING'
});

export const getStationsForStatusReportSuccess = stations => ({
    type: 'GET_STATIONS_FOR_STATUS_REPORT_SUCCESS',
    stations
});

export const getStationsForStatusReportError = error => ({
    type: 'GET_STATIONS_FOR_STATUS_REPORT_ERROR',
    error
});

export const requestWeatherStationStatusReportSuccess = () => ({
    type: 'REQUEST_WEATHER_STATION_STATUS_REPORT_SUCCESS'
});

export const clearWeatherStationStatusReport = () => ({
    type: 'CLEAR_WEATHER_STATION_STATUS_REPORT'
});

export const getWeatherStationStatusReports = () => {
    return dispatch => {
        dispatch(getWeatherStationStatusReportsPending());

        return fetch(`${process.env.REACT_APP_API_URL}/weather_station/getStatusReportList`, {
            method: 'GET',
            headers: defaultHeaders()
        })
            .then(res => handleJsonResponse(res, getWeatherStationStatusReportsError, dispatch))
            .then(res => {
                dispatch(getWeatherStationStatusReportsSuccess(res));
                return res;
            })
            .catch(err => {
                console.log('ERROR', err);
                throw err;
            });
    };
};

export const getWeatherStationStatusReport = reportId => {
    return dispatch => {
        dispatch(getWeatherStationStatusReportPending());

        return fetch(`${process.env.REACT_APP_API_URL}/weather_station/getStatusReport?reportId=${reportId}`, {
            method: 'GET',
            headers: defaultHeaders()
        })
            .then(res => handleJsonResponse(res, getWeatherStationStatusReportError, dispatch))
            .then(res => {
                dispatch(getWeatherStationStatusReportSuccess(res));
                return res;
            })
            .catch(err => {
                console.log('ERROR', err);
                throw err;
            });
    };
};

export const deleteWeatherStationStatusReport = reportId => {
    return dispatch => {
        dispatch(getWeatherStationStatusReportsPending());

        return fetch(`${process.env.REACT_APP_API_URL}/weather_station/deleteStatusReport?reportId=${reportId}`, {
            method: 'DELETE',
            headers: defaultHeaders()
        })
            .then(res => handleEmptyResponse(res, getWeatherStationStatusReportsError, dispatch))
            .then(() => dispatch(getWeatherStationStatusReports()))
            .catch(err => {
                console.log('ERROR', err);
                throw err;
            });
    };
};

export const getStationsForStatusReport = () => {
    return dispatch => {
        dispatch(getStationsForStatusReportPending());

        return fetch(`${process.env.REACT_APP_API_URL}/weather_station/getStationListForReport`, {
            method: 'GET',
            headers: defaultHeaders()
        })
            .then(res => handleJsonResponse(res, getStationsForStatusReportError, dispatch))
            .then(res => {
                dispatch(getStationsForStatusReportSuccess(res));
                return res;
            })
            .catch(err => {
                console.log('ERROR', err);
                throw err;
            });
    };
};

export const requestWeatherStationStatusReport = stationIds => {
    return dispatch => {
        return fetch(`${process.env.REACT_APP_API_URL}/weather_station/requestStatusReport`, {
            method: 'POST',
            headers: defaultHeaders(),
            body: JSON.stringify({stationIds})
        })
            .then(res => handleJsonResponse(res, getWeatherStationStatusReportsError, dispatch))
            .then(res => {
                dispatch(requestWeatherStationStatusReportSuccess());
                setTimeout(() => dispatch(getWeatherStationStatusReports()), 3000);
                return res;
            })
            .catch(err => {
                console.log('ERROR', err);
                throw err;
            });
    };
};
